<template>


    <dialog-fullscreen :visibility.sync='visibility' :indicator='indicator'>
        <template v-slot:title>Добавление источника данных</template>
        <template v-slot:action>
            <v-btn
                text
                :loading='indicator'
                color='green darken-2'
                @click="createDataSource"
            >
                Добавить
            </v-btn>
        </template>
        <template v-slot:content>
            <v-form v-model="validDataSource" style='min-width: 320px; max-width: 420px;'>

                <v-autocomplete
                    :items='$store.state.dataSourceTypes'
                    item-text='name'
                    label='Провайдер данных'
                    v-model="dataSource.data_source_type_id"
                    item-value="id"
                    single-line
                    :rules="[rules.required]"
                ></v-autocomplete>

                <v-text-field v-model="dataSource.data_source_name" :rules="[rules.required]"
                              label="Отображаемое название источника">

                </v-text-field>

                <template v-if="dataSource.data_source_type_id === 'wordstat'">

                    <v-autocomplete
                        :loading='ya.list'
                        :items='ya.accounts'
                        label='Аккаунт Яндекса'
                        v-model="dataSource.data_source_int.parent"
                        single-line
                    >
                    </v-autocomplete>

                    <label>Слова и фраза(ы) </label>
                    <v-tooltip
                        :open-on-hover="true"
                        top
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <label style="color: red; font-weight: bold" v-bind="attrs" v-on="on"><span><v-icon>info</v-icon></span></label>
                        </template>
                        <div>
                            Список ключевых слов и фраз (словосочетании), по которым требуется получить статистику (не
                            более 10 слов и фраз).<br>
                            Ключевые фразы могут содержать минус-фразы. <br>
                            Минус-фразу из нескольких слов следует заключить в скобки. <br>
                            Например: <b>холодильник -морозильник -(морозильная камера) -ремонт</b>.
                        </div>
                    </v-tooltip>

                    <vue-tags-input
                        v-model="phrase"
                        :tags="dataSource.data_source_int.phrases"
                        :max-tags="10"
                        :allow-edit-tags="true"
                        placeholder="Добавьте фразу"
                        @tags-changed="newPhrases => dataSource.data_source_int.phrases = newPhrases"
                    />
                    <br>
                    <label>Выберите регион(ы)</label>
                    <treeselect
                        v-model="dataSource.data_source_int.regions"
                        :multiple="true"
                        :options="regions"
                        :normalizer="normalize"
                        placeholder="Выберите регион(ы)"
                        return-object
                    />

                    <v-container>
                        <v-row justify='center'>
                            <v-col cols="4" class="custom-cols">
                                Суммарно
                            </v-col>
                            <v-col cols="4" class="custom-cols custom-switch">
                                <v-switch
                                    v-model="dataSource.meta.structure"
                                    false-value="summary"
                                    true-value="detailed"
                                ></v-switch>
                            </v-col>
                            <v-col cols="4" class="custom-cols">
                                Детализированно
                            </v-col>
                        </v-row>
                    </v-container>
                </template>

                <template v-if="dataSource.data_source_type_id === 'similarweb'">

                    <v-autocomplete
                        :loading='similarweb.list'
                        :items='similarweb.accounts'
                        label='Аккаунт SimilarWeb'
                        v-model="dataSource.data_source_int.parent"
                        single-line
                    >
                    </v-autocomplete>

                    <v-text-field v-model="dataSource.data_source_int.website" :rules="[rules.url, rules.required]"
                                  label="URL сайта">

                    </v-text-field>

                </template>


            </v-form>
        </template>
    </dialog-fullscreen>
</template>

<style>
    .custom-cols {
        display: flex;
        justify-content: center !important;
    }

    .custom-switch {
        padding: 0 0 0 0;
    }
</style>

<script>
    import Treeselect from '@riophae/vue-treeselect'
    import VueTagsInput from '@johmun/vue-tags-input';
    import DialogFullscreen from '@/components/elements/dialogs/Fullscreen.vue';
    import '@riophae/vue-treeselect/dist/vue-treeselect.css';


    export default {
        name: 'DataSourceCreateMenu',
        props: ['postAction', 'project', 'initialState'],
        components: {'dialog-fullscreen': DialogFullscreen, VueTagsInput, Treeselect},
        data() {
            return {
                validDataSource: false,
                visibility: this.initialState,
                indicator: false,
                phrase: '',
                dataSource: {
                    data_source_type_id: null,
                    data_source_name: "",
                    data_source_ext: {},
                    data_source_int: {
                        phrases: [],
                        regions: [],
                        parent: "",
                        website: ""
                    },
                    meta: {
                        structure: "summary"
                    },
                    project_id: this.project.project_id,
                    vertical_id: this.project.vertical_id
                },
                regions: [],
                flat_regions: [],
                ya: {
                    list: false,
                    get: false,
                    credentials: {},
                    accounts: [],
                    counters: [],
                    selection: {}
                },
                similarweb: {
                    list: false,
                    get: false,
                    credentials: {},
                    accounts: [],
                    counters: [],
                    selection: {}
                },
                structureTypes: [
                    {
                        value: 'summary',
                        text: 'Суммарно',
                    },
                    {
                        value: 'detailed',
                        text: 'Детализировано',
                    },
                ],
                selectedTypeProvider: {},
                selectedType: {},
                formStatus: true,
                rules: {
                    required: value => !!value || 'Обязательное поле',
                    url: value => {
                        const pattern = /(https?:\/\/[^\s]+)/g
                        return pattern.test(value) || 'Нераспознанный формат ссылки'
                    }
                }

            }
        },
        computed: {},
        methods: {
            toogle() {
                console.log(this.dataSource.data_source_int.regions)
                const sub_regions = this.regions.filter(el => el.parent_id === this.dataSource.data_source_int.regions[0].id).map(({children, ...keepAttributes}) => keepAttributes)
                console.log(sub_regions)
            },
            formValidate() {
                const data_source_name = this.dataSource.data_source_name;
                const parent = this.dataSource.data_source_int.parent;
                let result = !this.validDataSource || !data_source_name || !parent;

                if (this.dataSource.data_source_type_id === 'wordstat') {
                    result |= !this.dataSource.data_source_int.phrases.length
                }

                if (this.dataSource.data_source_type_id === 'similarweb') {
                    result |= !this.dataSource.data_source_int.website
                }
                return !!result;
            },
            normalize(node) {
                return {
                    id: node.region_id,
                    label: node.region_name,
                    children: node.children
                }
            },
            getYACredentials() {
                this.ya.list = true;
                let requestHeaders = {
                    'Content-Type': 'application/json;charset=UTF-8'
                };
                let requestData = {
                    'login': this.$store.getters.userLogin,
                };
                this.$http.put(this.$store.getters.endpoint + '/db/connect_ya',
                    requestData, {
                        headers: {...this.$store.state.restrictedHeaders, ...requestHeaders}
                    }).then((r) => {
                    let response = r.body;
                    if (response.result) {
                        this.ya.list = false;
                        this.ya.accounts = response.list
                    } else {
                        console.log(response)
                    }
                })
            },
            getSimilarWebCredentials() {
                this.similarweb.list = true;
                let requestHeaders = {
                    'Content-Type': 'application/json;charset=UTF-8'
                };
                let requestData = {
                    'login': this.$store.getters.userLogin,
                };
                this.$http.put(this.$store.getters.endpoint + '/db/connect_similar_web',
                    requestData, {
                        headers: {...this.$store.state.restrictedHeaders, ...requestHeaders}
                    }).then((r) => {
                    let response = r.body;
                    if (response.result) {
                        this.similarweb.list = false;
                        this.similarweb.accounts = response.list
                    } else {
                        console.log(response)
                    }
                })
            },
            getRegions() {
                this.$http.get(this.$store.getters.endpoint + '/db/list', {
                    emulateJSON: true,
                    params: {'login': this.$store.getters.userLogin, 'kind': 'regions'},
                    headers: this.$store.state.restrictedHeaders
                }).then(
                    r => {
                        let response = r.body;
                        if (response.result) {
                            this.regions = response.data.grouped_data;
                            this.flat_regions = response.data.flat_data;
                        } else {
                            console.log(response)
                        }
                    }
                )
            },
            fillDefault() {
                this.dataSource = {
                    data_source_type_id: null,
                    data_source_name: "",
                    data_source_ext: {},
                    data_source_int: {
                        phrases: [],
                        regions: [],
                        parent: "",
                        website: ""
                    },
                    meta: {
                        structure: "summary"
                    },
                    project_id: this.project.project_id,
                    vertical_id: this.project.vertical_id
                }
            },
            createDataSource() {
                this.indicator = true;
                let requestHeaders = {
                    'Content-Type': 'application/json;charset=UTF-8'
                }
                const requestData = {
                    login: this.$store.getters.userLogin
                };
                const i = {
                    ...this.dataSource,
                    data_source_int: {
                        phrases: this.dataSource.data_source_int.phrases.map(el => el.text),
                        regions: this.flat_regions.filter(el => {
                            return this.dataSource.data_source_int.regions.indexOf(el.region_id) !== -1
                        }),
                        parent: this.dataSource.data_source_int.parent,
                        website: this.dataSource.data_source_int.website
                    },
                    data_source_ext: {
                        phrases: this.dataSource.data_source_int.phrases.map(el => el.text),
                        regions: this.flat_regions.filter(el => {
                            return this.dataSource.data_source_int.regions.indexOf(el.region_id) !== -1
                        }),
                        parent: this.dataSource.data_source_int.parent,
                        website: this.dataSource.data_source_int.website
                    },
                    meta: this.dataSource.meta
                };

                console.log(i)

                this.$http.post(this.$store.getters.endpoint + '/db/project/' + this.project.project_id + '/datasources', {
                    ...requestData,
                    ...{'datasource': i}
                }, {
                    headers: {
                        ...this.$store.state.restrictedHeaders,
                        ...requestHeaders
                    }
                }).then(
                    r => {
                        this.indicator = false;
                        this.visibility = false;
                        let response = r.body;
                        if (response.result) {
                            this.postAction('datasources')
                        } else {
                            this.errorCreate = true;
                            console.log(response)
                        }
                    }, (r) => {
                        this.indicator = false;
                        let error = r.body;
                        console.log(error)
                    }
                )

            }
        },
        watch: {
            initialState(value) {
                this.visibility = value;
                if (value) {
                    this.fillDefault();
                    this.getRegions();
                    this.getYACredentials();
                    this.getSimilarWebCredentials();

                }
            },
            visibility(value) {
                this.$emit('update:initialState', value);
            },
        }
    }

</script>
